import { FaWeight } from "react-icons/fa"

function Infrastructure() {
  return (
    <>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb4">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Infrastructure Solutions
          </h4>
        </div>
      </div>

      {/* Main Section */}
      <div className="container">
        <section className="portfolio section-padding" id="portfolio">
          <div className="row">
            <div className="section-title wow zoomIn">
              <div className="indented">

                {/* Intro Section with Image */}
                <section className="mb-5">
                  <h2>With Celersoft infrastructure solutions, organizations can:</h2>
                  <div className="row align-items-center mt-4">
                    <div className="col-lg-7">
                      <p>
                        Empower your business with robust, scalable, and secure infrastructure solutions
                        designed to support today’s digital demands. Our Infrastructure Solutions team
                        specializes in building and optimizing IT infrastructure that aligns with your business
                        goals, ensuring high performance, reliability, and seamless scalability. From cloud
                        integration to on-premises data centers, our solutions cater to businesses across
                        industries, equipping them with the necessary tools and support for a resilient IT environment.
                      </p>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/infra1.jpg"
                        alt="Infrastructure Solutions"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "320px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>
                </section>

                {/* Our Infrastructure Solution Offerings */}
                <section className="wow fadeInUp" data-wow-delay="0.3s">
                  <h3 className="mb-4 text-center">Our Infrastructure Solution Offerings</h3>

                  {/* 1 */}
                  <div className="row align-items-center mb-5">
                    <div className="col-lg-7">
                      <h5>1. IT Infrastructure Assessment and Strategy</h5>
                      <ul>
                        <li>
                          Comprehensive assessment of your existing infrastructure to identify gaps and opportunities for optimization.
                        </li>
                        <li>
                          Strategic planning to align IT infrastructure with current and future business objectives.
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/infra2.jpg"
                        alt="Infrastructure Assessment"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "300px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>

                  {/* 2 */}
                  <div className="row align-items-center mb-5 flex-lg-row-reverse">
                    <div className="col-lg-7">
                      <h5>2. Cloud Infrastructure Services</h5>
                      <ul>
                        <li>
                          Design, deployment, and management of cloud infrastructure (public, private, or hybrid)
                          tailored to your business needs.
                        </li>
                        <li>
                          Secure and scalable cloud solutions, with ongoing support for smooth migration and minimal downtime.
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/infra3.png"
                        alt="Cloud Infrastructure"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "300px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>

                  {/* 3 */}
                  <div className="row align-items-center mb-5">
                    <div className="col-lg-7">
                      <h5>3. Data Center Solutions</h5>
                      <ul>
                        <li>
                          Design and deployment of on-premises and hybrid data centers with a focus on security,
                          energy efficiency, and operational resilience.
                        </li>
                        <li>
                          Support for hardware management, virtualization, and automation to ensure uninterrupted performance.
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/infra4.jpg"
                        alt="Data Center"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "300px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>

                  {/* 4 */}
                  <div className="row align-items-center mb-5 flex-lg-row-reverse">
                    <div className="col-lg-7">
                      <h5>4. Network Infrastructure Solutions</h5>
                      <ul>
                        <li>
                          Comprehensive network design, setup, and optimization for faster, more reliable connectivity.
                        </li>
                        <li>
                          Solutions for WAN, LAN, and SD-WAN to support multi-location and remote access demands.
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/infra5.png"
                        alt="Network Infrastructure"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "300px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>

                  {/* 5 */}
                  <div className="row align-items-center mb-5">
                    <div className="col-lg-7">
                      <h5>5. Storage and Backup Solutions</h5>
                      <ul>
                        <li>
                          Scalable storage solutions to manage data growth securely and cost-effectively.
                        </li>
                        <li>
                          Backup and disaster recovery services to ensure data integrity and continuity in the event of disruptions.
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/infra6.png"
                        alt="Storage and Backup"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "300px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>

                  {/* 6 */}
                  <div className="row align-items-center mb-5 flex-lg-row-reverse">
                    <div className="col-lg-7">
                      <h5>6. Virtualization and Hyper-Converged Infrastructure</h5>
                      <ul>
                        <li>
                          Enable greater resource efficiency with virtualization and hyper-converged systems,
                          maximizing IT assets while minimizing physical footprint.
                        </li>
                        <li>
                          Solutions for virtual machines, storage, and networking to simplify infrastructure management.
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/infra7.png"
                        alt="Virtualization"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "300px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>

                  {/* 7 */}
                  <div className="row align-items-center mb-5">
                    <div className="col-lg-7">
                      <h5>7. Infrastructure Monitoring and Management</h5>
                      <ul>
                        <li>
                          24/7 monitoring and support for proactive issue detection and quick response.
                        </li>
                        <li>
                          Automated alerts, reporting, and regular maintenance to optimize infrastructure performance and longevity.
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/infra8.png"
                        alt="Infrastructure Monitoring"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "300px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>
                </section>

                {/* Why Choose Our Infrastructure Solutions? */}
                <h3>Why Choose Our Infrastructure Solutions?</h3>
                <ul style={{ marginBottom: -30, padding: "0% 1% 1% 1" ,fontWeight:400}}>
                  <li>Over 30+ successful engagements in last 2 years</li>
                  <li>100% of all projects are completed on time</li>
                  <li>Strong Alliances with Oracle, SAP, and Salesforce.com</li>
                  <li>
                    <strong>Industry Expertise</strong>: Decades of experience designing and managing
                    complex IT environments across various sectors.
                  </li>
                  <li>
                    <strong>Scalable and Secure Solutions</strong>: Infrastructure tailored to grow with
                    your business needs, keeping security and compliance as a top priority.
                  </li>
                  <li>
                    <strong>End-to-End Support</strong>: From planning to implementation and ongoing
                    management, we provide support at every stage of the infrastructure lifecycle.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
      <br />

      {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p>
                <span style={{ fontSize: 20 }}>
                  <em><strong>USA</strong></em>
                </span>
              </p>
              <p>
                <i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br />
                Ste 355 Houston, TX 77077
              </p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p>
                <em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em>
              </p>
              <p>
                <i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9
              </p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p>
                <span style={{ fontSize: 20 }}>
                  <em><strong>INDIA</strong></em>
                </span>
              </p>
              <p>
                <i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road,
                Nizampet, Hyderabad, Telangana - 500085
              </p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com">
                  <i className="fas fa-envelope me-2" /> info@celersoft.com
                </a>
                <a href="tel:+18322258898">
                  <i className="fas fa-phone me-2" /> (+1) 832-225-8898
                </a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" /> 2024 Celersoft. All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </div>

      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>
    </>
  );
}

export default Infrastructure;
